import { takeLatest } from 'redux-saga/effects';
import {
  getCategoryListSuccess, getCategoryListFail,
  getVoucherListSuccess, getVoucherListFail,
  getMerchantListSuccess, getMerchantListFail,
  getMerchantDetailsSuccess, getMerchantDetailsFail,
  doAddToCartSuccess, doAddToCartFail,
  getMyActiveCartSuccess, getMyActiveCartFail,
} from './hyvidStoreState';
import createCrudService from '../../services/crudservice';
import { 
	doCrudCall
} from '../../utils/crudSagaHelper';

const storeService = createCrudService('api/v1/console/gift-store');
const redirectData = {route:'/console/hyvid-stores', mode: 'list', recordId:0 };

function* getCategoryList(data) {
	yield doCrudCall(
		() => storeService.doGetRequest(`category-list`, data.payload), 
		getCategoryListSuccess, 
		getCategoryListFail);
}

function* getMerchantList(data) {
	yield doCrudCall(
		() => storeService.doGetRequest(`merchant-list`, data.payload), 
		getMerchantListSuccess, 
		getMerchantListFail);
}

function* getMerchantDetails(data){
	console.log(data.payload);
	const { merchantId } = data.payload;
	if(merchantId){
		yield doCrudCall(
			() => storeService.doGetRequest(`merchant-info/${merchantId}`), 
			getMerchantDetailsSuccess, 
			getMerchantDetailsFail);
	}
}

function* getVoucherList(data) {
	yield doCrudCall(
		() => storeService.doGetRequest(`voucher-list`, data.payload), 
		getVoucherListSuccess, 
		getVoucherListFail);
}

function* getMyActiveCart(){
	yield doCrudCall(
		() => storeService.doGetRequest(`active-cart`), 
		getMyActiveCartSuccess, 
		getMyActiveCartFail);
}

function* doAddToCart(data) {
	yield doCrudCall(
		() => storeService.doPostRequest(`add-to-cart`, data.payload), 
		doAddToCartSuccess, 
		doAddToCartFail);
}

function* hyvidStoreSaga() {
  yield takeLatest('hyvidStore/getCategoryList', getCategoryList);
  yield takeLatest('hyvidStore/getMerchantList', getMerchantList);
  yield takeLatest('hyvidStore/getMerchantDetails', getMerchantDetails);
  yield takeLatest('hyvidStore/getVoucherList', getVoucherList);
  yield takeLatest('hyvidStore/getMyActiveCart', getMyActiveCart);
  yield takeLatest('hyvidStore/doAddToCart', doAddToCart);
  
//   yield takeLatest('hyvidStore/getHyvidStoreDetails', getHyvidStoreDetails);
//   yield takeLatest('hyvidStore/doHyvidStoreCreate', doHyvidStoreCreate);
//   yield takeLatest('hyvidStore/doHyvidStoreUpdate', doHyvidStoreUpdate);
//   yield takeLatest('hyvidStore/doHyvidStoreDelete', doHyvidStoreDelete);  
}

export default hyvidStoreSaga;
